import { render, staticRenderFns } from "./TdkManage.vue?vue&type=template&id=4ce3a228&scoped=true&"
import script from "./TdkManage.vue?vue&type=script&lang=js&"
export * from "./TdkManage.vue?vue&type=script&lang=js&"
import style0 from "./TdkManage.vue?vue&type=style&index=0&id=4ce3a228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3a228",
  null
  
)

export default component.exports